import React from 'react';
import { Box, Typography, Button, Link } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

type MessageProps = {
  message: any;
  onButtonClick?: (button: any) => void;
};

const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';

  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')
    .replace(/_(.*?)_/g, '<i>$1</i>')
    .replace(/~(.*?)~/g, '<s>$1</s>')
    .replace(/```(.*?)```/g, '<code>$1</code>')
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
    .replace(/\n/g, '<br />');
};

const MessageButtons: React.FC<MessageProps> = ({ message, onButtonClick }) => {
  try {
    const content = message?.content || {};
    const header = content?.header || {};
    const headerType = (header?.type || '').toUpperCase();
    const bodyText = content?.body?.text || content?.text || 'No message content available';
    const footerText = content?.footer?.text || '';
    const buttons = content?.buttons || [];

    const renderHeader = () => {
      if (!header || !headerType) return null;

      switch (headerType) {
        case 'IMAGE':
          return header?.link ? (
            <Box
              component="img"
              src={header.link}
              alt="header"
              sx={{
                width: '100%',
                maxHeight: 260,
                objectFit: 'cover',
                borderRadius: '8px',
                mb: 1,
              }}
            />
          ) : null;

        case 'VIDEO':
          return header?.link ? (
            <Box
              component="video"
              src={header.link}
              controls
              sx={{
                width: '100%',
                maxHeight: 260,
                borderRadius: '8px',
                mb: 1,
              }}
            />
          ) : null;

        case 'DOCUMENT':
          return header?.link ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 1,
                mb: 1,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#fafafa',
              }}
            >
              <InsertDriveFileIcon fontSize="small" />
              <Link href={header.link} target="_blank" rel="noopener noreferrer" underline="hover">
                {header?.filename || 'View document'}
              </Link>
            </Box>
          ) : null;

        case 'TEXT':
          return header?.text ? (
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              dangerouslySetInnerHTML={{ __html: formatText(header.text) }}
            />
          ) : null;

        default:
          return null;
      }
    };

    return (
      <Box>
        {renderHeader()}

        {/* Body */}
        <Typography
          variant="body2"
          sx={{ whiteSpace: 'pre-wrap', mb: buttons.length ? 2 : 0 }}
          dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
        />

        {/* Buttons */}
        {buttons.length > 0 && (
          <Box display="flex" flexDirection="column" gap={1.2}>
            {buttons.map((button: any, index: number) => (
              <Button
                key={index}
                variant="outlined"
                fullWidth
                sx={{
                  borderRadius: '20px',
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
                onClick={() => onButtonClick?.(button)}
              >
                {button.label}
              </Button>
            ))}
          </Box>
        )}

        {/* Footer */}
        {footerText && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mt={1}
            dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
          />
        )}
      </Box>
    );
  } catch (error) {
    return <Typography color="error">Error displaying button message</Typography>;
  }
};

export default MessageButtons;

// import React from 'react';
// import { Box, Typography, Button } from '@mui/material';

// type MessageProps = {
//   message: any;
//   onButtonClick?: (button: any) => void;
// };

// const formatText = (text: any): string => {
//   if (typeof text !== 'string') return '';
  
//   return text
//     .replace(/&/g, '&amp;')
//     .replace(/</g, '&lt;')
//     .replace(/>/g, '&gt;')
//     .replace(/\*(.*?)\*/g, '<b>$1</b>')        
//     .replace(/_(.*?)_/g, '<i>$1</i>')        
//     .replace(/~(.*?)~/g, '<s>$1</s>')       
//     .replace(/```(.*?)```/g, '<code>$1</code>') 
//     .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
//     .replace(/\n/g, '<br />');                 
// };

// const MessageButtons: React.FC<MessageProps> = ({ message, onButtonClick }) => {
//   try {
//     const content = message?.content || {};
//     const headerText = content?.header?.text || '';
//     const bodyText = content?.body?.text || content?.text || 'No message content available';
//     const footerText = content?.footer?.text || '';
//     const buttons = content?.buttons || [];

//     return (
//       <Box>
//         {/* Header */}
//         {headerText && (
//           <Typography variant="subtitle1" fontWeight="bold" gutterBottom  dangerouslySetInnerHTML={{ __html: formatText(headerText) }}> 
//             {/* {headerText} */}
//           </Typography>
//         )}

//         {/* Body */}
//         <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: buttons.length ? 2 : 0 }} dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
// >
//           {/* {bodyText} */}
//         </Typography>

//         {/* Buttons */}
//         {buttons.length > 0 && (
//           <Box display="flex" flexDirection="column" gap={1.2}>
//             {buttons.map((button: any, index: number) => (
//               <Button
//                 key={index}
//                 variant="outlined"
//                 fullWidth
//                 sx={{
//                   borderRadius: '20px',
//                   textTransform: 'none',
//                   fontWeight: 'bold',
//                 }}
//                 onClick={() => onButtonClick?.(button)}
//               >
//                 {button.label}
//               </Button>
//             ))}
//           </Box>
//         )}

//         {/* Footer */}
//         {footerText && (
//           <Typography variant="caption" color="text.secondary" display="block" mt={1} dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
// >
//             {/* {footerText} */}
//           </Typography>
//         )}
//       </Box>
//     );
//   } catch (error) {
//     return <Typography color="error">Error displaying button message</Typography>;
//   }
// };

// export default MessageButtons;
